<script setup lang="ts">
interface Props {
  modelValue?: string;
  type?: string;
  color?: "normal" | "error";
}
interface Emits {
  (e: "update:modelValue", value: string): void;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  type: "text",
  color: "normal",
});
const emit = defineEmits<Emits>();

function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}

const propsClass = computed(() => {
  const className = [];
  if (props.color) {
    className.push(`color-${props.color}`);
  }

  return className;
});
</script>

<template>
  <input
    class="text-base border px-2"
    :class="propsClass"
    :type="type"
    :value="modelValue"
    autocomplete="off"
    @input="handleInput"
  />
</template>
<style scoped lang="scss">
.color {
  &-normal {
    @apply border-gray-200;
  }
  &-error {
    @apply border-red-400 bg-red-100;
  }
}
</style>
